import { render, staticRenderFns } from "./prolusion.vue?vue&type=template&id=6a0f7572&scoped=true"
import script from "./prolusion.vue?vue&type=script&lang=js"
export * from "./prolusion.vue?vue&type=script&lang=js"
import style0 from "./prolusion.vue?vue&type=style&index=0&id=6a0f7572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f7572",
  null
  
)

export default component.exports